import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { UserType } from '../types/types';
import { IChainId, ITransactionType } from './type';

interface StoreState {
  user: UserType | undefined;
  setUser: (user: UserType | undefined) => void;
  deviceId: string | undefined;
  setDeviceId: (deviceId: string | undefined) => void;
  transactions: {
    [key in IChainId]?: ITransactionType[];
  };
  setTransactions: (
    deviceId:
      | {
          [key in IChainId]?: ITransactionType[];
        }
      | undefined
  ) => void;
}

const persistedState = persist<StoreState>(
  set => ({
    deviceId: undefined,
    setDeviceId: (deviceId: string | undefined) => set({ deviceId: deviceId }),
    user: undefined,
    setUser: (user: UserType | undefined) => set({ user: user }),
    transactions: {},
    setTransactions: (
      transactions: {
        [key in IChainId]?: ITransactionType[];
      }
    ) => set({ transactions: transactions }),
  }),
  { name: 'tomo-local' }
);

const useLocalStore = create(devtools(persistedState));

export const localStore = useLocalStore;

export default useLocalStore;
